/*
 Author: Virgilio Vazquez, Andrés Aguilar
 Email: andresyoshimar@gmail.com
 Date: 23/09/2019
 Modified: 09/12/2019
 Version: 0.0.3
*/
import Vue from 'vue'
import store from './../../store'
import accountTransformer from '../../transformers/account'

const updateStore = (accountData) => {
  store.dispatch('account/update', accountData)
}

export default (accountData) => {
  const data = accountTransformer.update(accountData)
  return Vue.$http.put('/user/current/', data).then(() => updateStore(accountData))
}


// WEBPACK FOOTER //
// ./src/services/account/update.js